import Tag from 'antd/lib/tag'
import styled from '@emotion/styled'

type TagTypes = 'active' | 'default'

export const CommonTag = styled<typeof Tag, { type?: TagTypes }>(Tag)(
  ({ type = 'default' }) => `
  display: block;
  
  width: fit-content;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  background-color: #ffffff;
  border: 1px solid ${type === 'active' ? '#d092dd' : '#4a4a68'};
  padding: 4px 12px;
  margin: 0;

  color: ${type === 'active' ? '#d092dd' : '#4a4a68'};
  font-weight: 500;
  font-size: 12px;
`
)
